var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._g({attrs:{"type":"submit","variant":"primary","disabled":_vm.isLoading}},_vm.$listeners),[(_vm.isLoading)?_c('b-spinner',{staticClass:"mx-2",staticStyle:{"position":"relative","bottom":"2px"},attrs:{"small":"","type":"grow"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.submitButtonText))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }